module.exports = __webpack_public_path__ + "img/slide5-en.71315507.png";